import { Event } from "../Event";

export class RequestLayoffFkCompanyIdEvents extends Event {
    public onChange = (value: any, setField: any, setState: any, formValues: any) => {
        if(value) {
            this.setState("loadings", ["request_layoff_fk_base_id"])

            this.setField("request_layoff_fk_base_id", {
                readonly: false
            })

            this.setFieldValue("request_layoff_fk_base_id", "")

            setTimeout(() => {
                this.setState("loadings", [])
            }, 250)
        }
    }
}